import { Toaster as Sonner } from 'sonner';

import { cn } from '~/utils/cn.ts';

import { useTheme } from '../utils/theme-utils.ts';

type ToasterProps = React.ComponentProps<typeof Sonner>;

const styles = {
	actionButton: 'group-[.toast]:bg-primary group-[.toast]:text-primary-foreground',
	cancelButton: 'group-[.toast]:bg-muted group-[.toast]:text-muted-foreground',
	description: 'group-[.toast]:text-muted-foreground',
	toast: cn(
		'toast group',
		'group-[.toaster]:bg-muted',
		'group-[.toaster]:text-foreground',
		'group-[.toaster]:border-border',
		'group-[.toaster]:shadow-lg',
	),
};

export function Toaster(props: React.ComponentProps<typeof Sonner>) {
	const theme = useTheme();

	return (
		<Sonner
			className="toaster group"
			theme={theme as ToasterProps['theme']}
			toastOptions={{
				classNames: styles,
			}}
			{...props}
		/>
	);
}
